/** API 文档：页面框架、章节标题与摘要、代码示例标签。 */
const messages = {
  'nav.label': '文档目录',
  'nav.pager': '上一节与下一节',
  'nav.prev': '上一节',
  'nav.next': '下一节',
  'page.eyebrow': 'API 文档 · {group}',
  'page.documentTitle': '{title} · API 文档 · aitoken.tools',
  'page.codeSamples': '代码示例',
  'page.loading': '正在加载文档',
  'site.cn': '国内站',
  'site.global': '海外站',

  'group.start': '入门',
  'group.models': '模型与计费',
  'group.assets': '素材',
  'group.tasks': '任务',
  'group.reliability': '可靠性',
  'group.reference': '参考',

  'quickstart.title': '快速开始',
  'quickstart.summary': '四步完成接入，提交第一个视频任务。',
  'quickstart.codeTitle': '创建视频任务',
  'authentication.title': 'Base URL 与鉴权',
  'authentication.summary': 'Bearer Key、请求格式、ID 与金额约定、分页。',
  'api-keys.title': 'Key 权限与限额',
  'api-keys.summary': 'scope、模型白名单、累计与日限额、停用与撤销。',
  'models.title': '模型能力表',
  'models.summary': '模式、分辨率、时长、比例与输入限制。',
  'pricing.title': '计价规则',
  'pricing.summary': '按输出 token 计价；冻结上界、结算与释放。',
  'uploads.title': '素材上传',
  'uploads.summary': '单文件、分片、URL 导入与创建素材。',
  'portrait-authorization.title': '素材类型与真人认证',
  'portrait-authorization.summary': 'trust_class、虚拟人物与真人照片的刷脸认证。',
  'tasks.title': '异步任务与状态',
  'tasks.summary': '状态机、失败码与请求字段。',
  'idempotency.title': '幂等',
  'idempotency.summary': 'Idempotency-Key 的语义与重试方式。',
  'polling.title': '轮询频率建议',
  'polling.summary': '退避轮询，终态即停。',
  'webhooks.title': 'Webhook 与验签',
  'webhooks.summary': '事件格式、X-Signature 验签与投递重试。',
  'webhooks.codeTitle': '验证签名',
  'errors.title': '错误码',
  'errors.summary': '统一错误体与全部错误码。',
  'retries.title': '重试建议',
  'retries.summary': '哪些错误该重试、怎么退避。',
  'retention.title': '结果留存',
  'retention.summary': '签名地址有效期与结果保留期。',
  'rate-limits.title': '限流',
  'rate-limits.summary': 'RPM、并发与限流响应头。',
  'reference.title': '接口参考（OpenAPI）',
  'reference.summary': '下载 openapi.json 与接口一览。',
  'changelog.title': '更新记录',
  'changelog.summary': '/v1 的变更历史。',

  'sample.errorResponse': '错误响应',
  'sample.errorMessage': '素材 asset_xxx 仍在处理中，请在状态变为 available 后重试',
  'sample.response': '响应',
  'sample.idempotencyKeyNote': '业务侧唯一 ID 作为幂等键：超时重试不会重复建任务',
  'sample.networkRetryNote': '网络错误：继续用同一个 key 重试',
  'sample.taskResult': '任务结果',
  'sample.rateLimited': '429 响应',
  'sample.urlImport': 'URL 导入',
  'sample.referenceAudio': '参考图 + 参考音频',
  'sample.webhookEvent': 'task.succeeded 事件（节选）',
};

export default messages;
